export const accountReferralPositionsStyle = {
  title: {
    sx: {
      color: 'action.active',
      pt: 3,
      pb: 2,
    },
  },
} as const;
